/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ElectronClientVersionResponse
 */
export interface ElectronClientVersionResponse {
    /**
     * SemVer version string of the user's most recently active Electron client (parsed server-side from User-Agent on main-process API calls). Null when the user has no active Electron client within the 60-minute presence window.
     * @type {string}
     * @memberof ElectronClientVersionResponse
     */
    electronClientVersion: string | null;
}

/**
 * Check if a given object implements the ElectronClientVersionResponse interface.
 */
export function instanceOfElectronClientVersionResponse(value: object): value is ElectronClientVersionResponse {
    if (!('electronClientVersion' in value) || value['electronClientVersion'] === undefined) return false;
    return true;
}

export function ElectronClientVersionResponseFromJSON(json: any): ElectronClientVersionResponse {
    return ElectronClientVersionResponseFromJSONTyped(json, false);
}

export function ElectronClientVersionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElectronClientVersionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'electronClientVersion': json['electronClientVersion'],
    };
}

export function ElectronClientVersionResponseToJSON(json: any): ElectronClientVersionResponse {
    return ElectronClientVersionResponseToJSONTyped(json, false);
}

export function ElectronClientVersionResponseToJSONTyped(value?: ElectronClientVersionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'electronClientVersion': value['electronClientVersion'],
    };
}

